import { Box, Stack } from '@mui/material';
import { DiagnosesInput } from './DiagnosesInput';
import { DiagnosesGroupItem, DiagnosesItem, PropsDiagnosesContext } from './DiagnosesInput.components';
import { DiagnosesSearchValueType, SelectedDiagnoses } from '@src/api';
import { useContext, useEffect } from 'react';

type DiagnosesTabProps = {
  handleClickScaleType: (value: DiagnosesSearchValueType) => void;
  dataTestId?: string;
};

export const DiagnosesTab: React.FC<DiagnosesTabProps> = ({ handleClickScaleType, dataTestId }) => {
  const { diagnosesInRule, diagnosesGroupsInRule, onDelete, onDeleteDiagnosesGroups } =
    useContext(PropsDiagnosesContext);

  useEffect(() => {
    handleClickScaleType(DiagnosesSearchValueType.ICD10);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const combinedItems = [
    ...diagnosesInRule.map(diagnosis => ({ type: 'diagnosis', data: diagnosis })),
    ...diagnosesGroupsInRule.map(group => ({ type: 'group', data: group })),
  ];

  return (
    <Box>
      <Box padding="24px 24px 18px">
        <DiagnosesInput heightPoper={468} handleClickScaleType={handleClickScaleType} dataTestId={dataTestId} />
      </Box>
      <Box overflow="auto" padding="1px 24px" sx={{ minHeight: '376px' }}>
        <Stack>
          {combinedItems.map((item, index) => {
            const backgroundColor = index % 2 === 0 ? '#F7FCFD' : '#FFFFFF';

            return item.type === 'diagnosis' ? (
              <DiagnosesItem
                sx={{
                  backgroundColor,
                  '&.Mui-expanded': {
                    padding: 0,
                    margin: 0,
                  },
                }}
                level={0}
                withCheckbox={false}
                key={item.data.id}
                diagnosis={item.data as SelectedDiagnoses}
                searchDiagnosesValue={''}
                onDelete={onDelete}
                backgroundColor={backgroundColor}
              />
            ) : (
              <DiagnosesGroupItem
                sx={{ backgroundColor }}
                key={item.data.id}
                id={item.data.id as number}
                name={item.data.name}
                onDeleteDiagnosesGroupsFromRule={onDeleteDiagnosesGroups}
                backgroundColor={backgroundColor}
              />
            );
          })}
        </Stack>
      </Box>
    </Box>
  );
};
